import Fade from '@mui/material/Fade';
import React, { FC, useState } from 'react';
import { SketchPicker } from 'react-color';
import { useTranslation } from 'react-i18next';
import { colors, fontSize, fontWeight, TypographyStyledGlobal } from '../../../theme';
import Title from '../../Title/title';
import { ColorPickerModalProps } from './colorPickerModalInterface';
import { ActionButtonStyled, BoxModalStyled, CloseIconModalStyled, ModalStyled } from './styled';
import './styles.css';

const ColorPickerModal: FC<ColorPickerModalProps> = ({ openModal, setOpenModal, fillColor, handleChangeFillColor, codemodalite }) => {
    const { t } = useTranslation('dashboard');
    const [pickerColor, setPickerColor] = useState(fillColor);
    const handleClose = () => {
        setOpenModal(false);
    };

    return (
        <ModalStyled
            aria-describedby="modal-modal-description"
            aria-labelledby="modal-modal-title"
            onClose={handleClose}
            open={openModal}
        >
            <Fade in={openModal}>
                <BoxModalStyled>
                    <Title content={t('colorModal.title')} modalTitle />
                    <CloseIconModalStyled onClick={handleClose} />
                    <SketchPicker
                        color={pickerColor}
                        onChange={(color: any) => setPickerColor(color.hex)}
                        presetColors={[]}
                        styles={{
                            default: {
                                picker: {
                                    padding: '0',
                                    backgroundColor: 'transparent',
                                    boxShadow: 'none',
                                },
                                color: {
                                    display: 'none',
                                },
                            },
                        }}
                        width='100%'
                        disableAlpha
                    />
                    <TypographyStyledGlobal
                        color={colors.grey200}
                        margin='8px 0 8px 0'
                        size={fontSize.sm}
                        weight={fontWeight.regular}
                    >
                        {t('colorModal.preview')}
                    </TypographyStyledGlobal>
                    <div style={{ display: 'flex' }}>
                        <div style={{ backgroundColor: pickerColor, height: 'auto', width: '50%', borderRadius: '8px' }} />
                        <ActionButtonStyled
                            onClick={() => {
                                if (codemodalite && pickerColor) {
                                    handleChangeFillColor(codemodalite, pickerColor);
                                }
                                handleClose();
                            }}
                            default
                        >
                            {t('colorModal.validate')}
                        </ActionButtonStyled>
                    </div>
                </BoxModalStyled>
            </Fade>

        </ModalStyled>
    );
};

export default ColorPickerModal;
